import styled from 'styled-components';
import { themeOptions } from 'assets/styles/theme';

export const ModalContainer = styled.div`
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  overflow: hidden;
  overscroll-behavior: contain;
`;

export const ModalContainerPaper = styled.div`
  background: ${themeOptions.palette.common.white};
  padding: 24px 20px;
  border-radius: 5px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: 850px) {
    width: 100%;
    height: 100%;
    max-height: 100%;
  }

  h6 {
    font-weight: 500;
    color: ${themeOptions.palette.text.primary};
  }

  p {
    padding: 0px 16px;
    font-size: 1 rem;
    color: ${themeOptions.palette.grey['300']};
    font-weight: 400;
    line-height: 1.5;
  }
`;

export const ModalTitleContainer = styled.div`
  flex-shrink: 0;
`;

export const ModalContainerTop = styled.div`
  display: flex;
  justify-content: flex-end;

  svg {
    cursor: pointer;
  }
`;

export const ModalContentContainer = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  svg {
    margin: 0 auto;
  }
`;

export const ModalFooterContainer = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
`;
